export const DELAY_CLOSE = 0.1;
export const DELAY_OPEN = 0.1;
export const TOOLBAR_ANIMATION_DURATION = 50;
